<template>
  <div class="px-4 mt-10">
    {{ $t("message.supersessions.title") }}
    <br />
    <input
      id="filter-input"
      type="text"
      class="regular clear full mb-10"
      :placeholder="$t('message.supersessions.filter_placeholder')"
      v-model="filter"
    />
    <div class="flex flex-row w-full">
      <div class="flex-grow grid grid-cols-3 gap-4 p-0 h-full">
        <input
          id="unificado-input"
          type="text"
          class="regular clear full"
          :placeholder="$t('message.supersessions.new_unificado')"
          v-model="unificado"
          :disabled="loading"
        />
        <input
          id="supersession-input"
          type="text"
          class="regular clear full"
          :placeholder="$t('message.supersessions.new_supersession')"
          v-model="newSS"
          :disabled="loading"
        />
        <input
          type="text"
          class="regular clear full"
          :placeholder="$t('message.supersessions.extra_info')"
          v-model="newSSInfo"
          :disabled="loading"
        />
      </div>
      <div id="action" class="w-24 pl-4 flex justify-center items-center">
        <button @click="createSupersession()">
          <img class="base-icon" src="@/assets/icons/add.svg" />
        </button>
      </div>
    </div>
    <SupersessionLineFull
      v-for="supersession in supersessions"
      :supersession="supersession"
      :key="supersession.ID"
      @deletedSupersession="
        id => {
          supersessions = supersessions.filter(supersession => {
            return supersession.ID != id;
          });
        }
      "
    >
    </SupersessionLineFull>
  </div>
</template>
<script>
import { createSupersession } from "@/api/store/SupersessionsService.js";
import { getSupersessions } from "@/api/masterAdmin/SupersessionsService.js";
import SupersessionLineFull from "@/components/product/SupersessionLineFull.vue";
export default {
  name: "SupersessionManagerPage",
  components: {
    SupersessionLineFull
  },
  data() {
    return {
      supersessions: [],
      filter: "",
      newSS: "",
      newSSInfo: "",
      unificado: "",
      loading: false
    };
  },
  computed: {
    supersessionsFiltered() {
      let supersessionsFiltered = [...this.supersessions];
      if (this.filter != "" && supersessionsFiltered) {
        supersessionsFiltered = supersessionsFiltered.filter(ss => {
          return ss.ALTERNATIVE.toLowerCase().includes(
            this.filter.toLowerCase()
          );
        });
      }
      return supersessionsFiltered;
    }
  },
  watch: {
    filter() {
      this.loadSupersessions();
    }
  },
  mounted() {
    this.loadSupersessions();
    document.getElementById("supersession-input").focus();
  },
  methods: {
    createSupersession() {
      this.loading = true;
      createSupersession(this.newSS, this.newSSInfo, this.unificado)
        .then(res => {
          this.supersessions.unshift({
            id: res.supersession.ID,
            alternative: res.supersession.ALTERNATIVE,
            unificado: res.supersession.UNIFICADO,
            info: res.supersession.info,
            last_edit: res.supersession.last_edit
          });
          this.$toast.open({
            message: "Supersession added",
            type: "success",
            position: "top-right"
          });
          this.newSS = "";
          this.newSSInfo = "";
          this.unificado = "";
          this.loading = false;
          this.$nextTick(() => {
            document.getElementById("supersession-input").focus();
          });
        })
        .catch(e => {
          this.$toast.open({
            message: e?.response?.data?.message || "Error on request!",
            type: "error",
            position: "top-right"
          });
          this.loading = false;
        });
    },
    async loadSupersessions() {
      this.supersessions = await getSupersessions(this.filter);
    }
  }
};
</script>
<style lang="scss" scoped>
#filter-input {
  width: 100%;
  margin: 10px 0px;
  text-align: center;
}
</style>
